// extracted by mini-css-extract-plugin
export default {"container":"catalog-item_container__ag-ES","link":"catalog-item_link__6-rWs","text":"catalog-item_text__wRPCA"};